import { ChainPipelinePage } from '@/pages/crm/chain/ChainPipelinePage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// A leaderboard row deep-links here pre-filtered to one member (member-leaderboard.md drill-in).
// `member` is a member company id; absent means the full board.
const pipelineSearchSchema = z.object({
	member: z.string().optional(),
	q: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/chain/pipeline')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainDistribution.distribute'], redirectTo: '/dashboard' }),
	component: ChainPipelinePage,
	validateSearch: pipelineSearchSchema,
});
